// Libraries
import { action, computed, observable } from "mobx";

// Core
import { ViewModelBase } from "Core/ViewModels";

// Custom
import { Server } from "Custom/Globals/AppUrls";
import { PortalThemeModel, PortalThemeDto } from "Custom/Models/DashboardModels/PortalThemeModel";
import { FieldType } from "Core/Utils/Utils";
import { ApiStatus } from "Custom/Models/Enums/ApiStatus";
import { StoresInstance } from "Custom/Stores";

export class PortalThemeViewModel extends ViewModelBase<PortalThemeModel> {
    constructor(companySlug?: string) {
        super(new PortalThemeModel());
        this.setDecorators(PortalThemeModel);

        this.companySlug = companySlug || "";

        sessionStorage.setItem("companySlug", this.companySlug);

        const cachedTheme = sessionStorage.getItem(this.storageKey);

        if (cachedTheme) {
            try {
                const parsedTheme = JSON.parse(cachedTheme);

                this.portalTheme.fromDto(parsedTheme);

                this.setApiStatus(ApiStatus.success);
            } catch {
                sessionStorage.removeItem(this.storageKey);
            }
        }

        if (this.companySlug) {
            this.loadPortalTheme(this.companySlug);
        }
    }

    @observable public companySlug: string = "";

    @observable public portalTheme: PortalThemeModel = new PortalThemeModel();
    @observable public apiStatus: ApiStatus = ApiStatus.loading;

    private loadPortalTheme = async (companySlug: string) => {
        this.setApiStatus(ApiStatus.loading);
        const result = await this.Post<PortalThemeDto>(Server.Api.PortalTheme.Get, { companySlug });

        try {
            if (result.wasSuccessful && result.payload) {
                this.portalTheme.fromDto(result.payload);

                sessionStorage.setItem(this.storageKey, JSON.stringify(result.payload));
                StoresInstance.domain.PortalThemeStore.setTheme(result.payload);

                this.setApiStatus(ApiStatus.success);
            } else {
                this.setApiStatus(ApiStatus.error);
            }
        } catch (exception) {
            this.setApiStatus(ApiStatus.error);
        } finally {
            // Finally
        }
    };

    // #region Actions

    @action
    public setApiStatus(apiStatus: ApiStatus) {
        this.apiStatus = apiStatus;
    }

    // #endregion Actions

    // #region Computed
    @computed public get storageKey(): string {
        return `portalTheme:${this.companySlug || "default"}`;
    }

    @computed public get ApiStatus(): ApiStatus {
        return this.apiStatus;
    }

    // #endregion Computed

    // #region Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }

    // #endregion Boilerplate
}
